var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-slide-y-transition',{attrs:{"mode":"out-in"}},[_c('v-container',{staticClass:" pa-0 pb-4 fluid"},[_c('v-layout',{attrs:{"column":""}},[_c('v-flex',{attrs:{"sm12":""}},[(_vm.showFormEks)?_c('explore-eks'):_vm._e()],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }